import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const cartQuery = () =>
  defineQuery({
    queryKey: queryKeys.cart.current(),
    queryFn: ({ signal }) => api.cart.get(signal),
    staleTime: 0,
  });
